import React from "react";

interface GradientTextProps {
  text: string;
  textAlign?: "left" | "center";
  size?: number; // Font size in px
  widthAuto?: boolean;
}

export const GradientText: React.FC<GradientTextProps> = ({
  text,
  textAlign,
  size,
  widthAuto,
}) => {
  const className = `gradient-text ${
    textAlign === "left" ? "gradient-text--left" : "gradient-text--center"
  } ${widthAuto ? "gradient-text--auto-width" : "gradient-text--full-width"}`;

  // Pass dynamic font-size via CSS variable
  // Fix: Explicitly cast to React.CSSProperties
  const style: React.CSSProperties = {
    "--gradient-text-font-size": size ? `${size}px` : undefined,
  } as React.CSSProperties; // Assert as CSSProperties

  return (
    <span className={className} style={style}>
      {text}
    </span>
  );
};
